import { fromJS } from 'immutable'
import {
  USER_EDIT_REQUEST,
  USER_EDIT_SUCCESS,
  USER_EDIT_FAILURE,
  USER_EDIT_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case USER_EDIT_REQUEST:
      return state
        .set('isFetching', true)
    case USER_EDIT_SUCCESS:
      return state
        .set('isFetching', false)
        .set('type', 'success')
        .set('status', 'Updated Successfully')
        .set('message', 'The data had successfully been updated')
        .set('employeeEdit', fromJS(action.payload.updatedUser))
    case USER_EDIT_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
        .set('type', 'error')
        .set('status', 'Error')
        .set('employeeEdit', fromJS(action.payload.message))
        .set('message', fromJS(action.payload.response.message))
    case USER_EDIT_RESET:
      return state
        .delete('employeeEdit')
        .delete('type')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/employee/employee-edit-reducer.js